import { Component, Injectable, Input, Output, EventEmitter } from "@angular/core";
import { NGXLogger } from "ngx-logger";
import { Router } from "@angular/router";

@Injectable()
export class PopUpService {
    isEnable: boolean = false;
    isLogin: boolean = false;
    isRegister: boolean = false;
    isOtp: boolean = false;
    isForgot: boolean = false;
    isLoginOtp: boolean = false;
    isChangePassword: boolean = false;
    isChangePasswordSucc: boolean = false;
    isInfo: boolean = false;
    isSuccessInfo: boolean = false;
    title: String;
    @Output() fire: EventEmitter<any> = new EventEmitter();

    constructor(private router: Router, private logger: NGXLogger) {
    }

    logout() {
        this.logger.debug("calling logout method....");
        sessionStorage.clear();
        localStorage.clear();
        localStorage.setItem("lang", "en");
        this.router.navigate[('home')];
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/PopUpService.ts